import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=65a8fd04&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8fd04",
  null
  
)

export default component.exports